declare const __SNAKELY_REVISION__: string;
declare const __SNAKELY_VERSION__: string;

export const buildConfig = {
  revision: __SNAKELY_REVISION__,
  version: __SNAKELY_VERSION__,
  versionLabel: `Version ${__SNAKELY_VERSION__} · ${__SNAKELY_REVISION__}`,
} as const;
